import React from "react";
import { motion } from "framer-motion";
import { WHAT_YOU_LEARN } from "@/constants/content";

const WhatYouWillLearn = () => (
  <section id="learn" className="section-pad relative bg-[#0f172a] text-white overflow-hidden">
    <div className="aurora opacity-70" aria-hidden />
    <div className="grain" aria-hidden />
    <div
      aria-hidden
      className="absolute inset-0 opacity-[0.06]"
      style={{
        backgroundImage:
          "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)",
        backgroundSize: "56px 56px",
        maskImage: "radial-gradient(ellipse at 50% 20%, black 40%, transparent 75%)",
        WebkitMaskImage: "radial-gradient(ellipse at 50% 20%, black 40%, transparent 75%)",
      }}
    />
    <div className="container-x relative z-10">
      <div className="max-w-3xl">
        <div className="chip-dark">What You Will Learn</div>
        <h2
          className="mt-3 font-display font-bold tracking-tight"
          style={{ fontSize: "clamp(2rem, 4vw, 3.25rem)" }}
        >
          Everything practical you need to <span className="gradient-text-lime">launch and grow</span>.
        </h2>
      </div>

      <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-3">
        {WHAT_YOU_LEARN.map((t, i) => (
          <motion.div
            key={t}
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10% 0px" }}
            transition={{ duration: 0.4, delay: (i % 12) * 0.03 }}
            className="group relative rounded-2xl p-4 border border-white/10 bg-white/[0.03] hover:bg-white/[0.06] transition-colors"
          >
            <div className="text-[10px] font-mono uppercase tracking-widest text-emerald-300/70">
              {String(i + 1).padStart(2, "0")}
            </div>
            <div className="mt-2 text-sm sm:text-base font-medium text-white">{t}</div>
            <div
              aria-hidden
              className="absolute inset-x-4 -bottom-px h-px bg-gradient-to-r from-transparent via-emerald-400/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"
            />
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default WhatYouWillLearn;
